export default __webpack_public_path__ + "static/media/post-schedule.e3a301ad.png";